// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_gt-0";
export var buttonContainer = "_gt-3";
export var cancelButton = "_gt-4";
export var headerSection = "_gt-6";
export var headerTitle = "_gt-9";
export var messageSideLeft = "_gt-1";
export var messageSideRight = "_gt-2";
export var orderNumberContainer = "_gt-7";
export var orderNumberLabel = "_gt-8";
export var submitButton = "_gt-5";